<div class="buttons-container">
  <div *ngFor="let item of buttonList" class="button-item">
    <div class="button-item-content" #buttonItemContentEl>
      <app-button
        class="icon"
        [buttonType]="item.active || item.hover ? 'primary' : 'normal'"
        [styleType]="item.active ? 'contained' : 'text'"
        shapeType="circle"
        sizeType="large"
        [icon]="item.icon"
        (click)="onBtnItemClick($event, item)"
        (mouseover)="item.hover = true"
        (mouseleave)="item.hover = false"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-button>
    </div>

    <app-tooltip
      *ngIf="!!item.tooltip"
      [target]="buttonItemContentEl"
      verticalAlignment="top"
      horizontalAlignment="center"
    >
      {{ item.tooltip }}
    </app-tooltip>
  </div>
</div>

<div class="buffer-parameters-container">
  <span class="label">{{ distanceText }}:</span>

  <app-input-box
    class="input"
    type="number"
    [(value)]="distance"
    [max]="maxDistance"
    [disabled]="isDistanceInputDisabled"
    [showErrorEnabled]="false"
    [showClearButton]="false"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-input-box>

  <span class="suffix">{{ metersText }}</span>
</div>
